//NE FELEJTSD EL AZ API MEG A /OVODÁT VISSZARAKNI LOCALHOSTRÓL

import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DatePicker from './MaterialUIPickers';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useState, useEffect } from 'react';
import './App.css';

const debug = false;
const api = debug === true ? 'http://127.0.0.1:5001/ovoda-beiratkozo/us-central1/app' : '';

const Item = styled(Paper)(({ theme }) => ({
  //backgroundColor: theme.palette.mode === 'dark' ? 'grey' : '#fff',
  //...theme.typography.body2,
  padding: theme.spacing(1),
  //color: theme.palette.text.secondary,
}));

const DateItemNeutral = styled(Paper)(({ theme }) => ({
  border: '1px solid grey',
  borderRadius: '5px',
  padding: theme.spacing(1),
  textAlign: 'center',
  ...theme.typography.body2,
}));

const DateItemBad = styled(Paper)(({ theme }) => ({
  border: '1px solid red',
  backgroundColor: 'rgb(255, 182, 182)',
  borderRadius: '5px',
  padding: theme.spacing(1),
  textAlign: 'center',
  ...theme.typography.body2,
  textDecoration: 'line-through'
}));


function App() {
  useEffect(() => {
    document.title = "Óvoda beiratkozó";   }, []);
  const [day, setDay] = React.useState('');
  const [c, setC] = React.useState(true);
  const [chosenFacility, setChosenFacility] = useState(false); //válaszott már ovit vagy bölcsit
  const [currentFacility, setCurrentFacility] = useState("");
  var color = true;
  const [setTrue, setSetTrue] = useState(null);
  //var setTrue;
  const dates = ['9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30'];
  const [takenDates, setTakenDates] = useState([]);
  const [errorInFill, setErrorInFill] = useState(false);
  const [result, setResult] = useState('not-sent');
  const [submitted, setSubmitted] = useState(false);
  
  useEffect (() => {
    fetch(api + `/${(color) ? 'ovoda': 'bolcsode'}`, {mode: 'cors'})
    .then(res => res.json())
    .then(data => setTakenDates(data));
  }, [color]);

  const handleChange = (event) => {
    setDay(event.target.value);
    if (setTrue) {
      document.getElementById(setTrue).style.border = '1px solid grey';
      document.getElementById(setTrue).style.backgroundColor = 'white';
    }
    setSetTrue(null);
    //setTrue = null;
  };

  function changeColor(e) {
    setChosenFacility(true);
    setDay(null);
    if (e.target.id ==='ovoda') {
      document.body.style = "background-color: var(--ovoda)";
      //document.getElementById('title').innerHTML = 'Óvodai beiratkozás';
      setCurrentFacility("Óvodai beiratkozás");
      color = true;
      setC(true);
    }
    else if (e.target.id === 'bolcsode') {
      document.body.style = "background-color: var(--bolcsode)";
      //document.getElementById('title').innerHTML = 'Bölcsődei beiratkozás';
      setCurrentFacility("Bölcsődei beiratkozás");
      color = false;
      setC(false);
    }
    fetch(api + `/${(color) ? 'ovoda': 'bolcsode'}`, {mode: 'cors'})
    .then(res => res.json())
    .then(data => setTakenDates(data));
    console.log(setTrue);
    if (setTrue && setTrue !== e.target.id) {
      document.getElementById(setTrue).style.border = '1px solid grey';
      document.getElementById(setTrue).style.backgroundColor = 'white';
    }
    setSetTrue(null);
    //setTrue = null;
  }

  function chosenDate(e){
    e.target.style.border = '1px solid green';
    e.target.style.backgroundColor = 'lightgreen';
    console.log(setTrue);
    if (setTrue && setTrue !== e.target.id) {
      document.getElementById(setTrue).style.border = '1px solid grey';
      document.getElementById(setTrue).style.backgroundColor = 'white';
    }
    setSetTrue(e.target.id);
    //setTrue = e.target.id;
  }
  function handleSubmit(e){
    e.preventDefault();
    var error = false;
    for (let index = 0; index < 10; index++) {
      if (e.target[index].value === ''){
        error = true;
        break;
      }
    }
    if (setTrue === null) {
      error = true;
    }
    if (!error){
      setSubmitted(true);
      var object = {
        child_name : e.target[0].value,
        name : e.target[1].value,
        email : e.target[2].value,
        phone : e.target[3].value,
        postal_code: e.target[4].value,
        town : e.target[5].value,
        address : e.target[6].value,
        date: e.target[7].value,
        day: e.target[9].value,
        hour: setTrue,
        facility : c === true ? 'ovoda' : 'bolcsode',
      }
      console.log(object);
      fetch(api + '/api', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify(object),
      }).then(e=>e.json()).then(e=>setResult(e.result));
    }
    else {
      setErrorInFill(true);
    }
  }

  if (!chosenFacility) {
    return(
      <>
          <div onClick={changeColor} id='ovoda'>Óvoda</div>
          <div onClick={changeColor} id='bolcsode'>Bölcsőde</div>
          <div id='pleaseChoose'>Kérjük válasszon intézményt!</div>
      </>
    )
  }
  else if (result === 'not-sent'){
    return (
      <>
        <div onClick={changeColor} id='ovoda'>Óvoda</div>
        <div onClick={changeColor} id='bolcsode'>Bölcsőde</div>
        <form onSubmit={handleSubmit}>
          <div className='form'>
          <h1 id='title'>{currentFacility}</h1>
          {errorInFill === true && <>
          <h3 className="incorrect-fill">Az összes mező kitöltése és időpont választása kötelező</h3>
          </>
          }
              <TextField id="gyermekNev" label="Gyermek neve" variant="standard" className='tf'/><br/>
              <TextField id="gondviseloNev" label="Gondviselő neve" variant="standard" className='tf'/><br/>
              <TextField id="email" label="E-mail" variant="standard" className='tf'/><br/>
              <TextField id="phone" label="Telefon" variant="standard"className='tf'/><br/>
              <Box className='addressBox'>
                <Grid container spacing={2}>
                  <Grid item xs={5}>
                    <Item className={c ? 'light' : 'dark'}><TextField id="postal_code" label="Irányítószám" variant="standard" type='number' className='address'/><br/></Item>
                  </Grid>
                  <Grid item xs={7}>
                    <Item className={c ? 'light' : 'dark'}><TextField id="town" label="Város" variant="standard" className='address'/><br/></Item>
                  </Grid>
                  <Grid item xs={12}>
                    <Item className={c ? 'light' : 'dark'}><TextField id="address" label="Lakcím" variant="standard" className='address'/><br/></Item>
                  </Grid>
                </Grid>
              </Box>
              <DatePicker></DatePicker><br/>
              <FormControl variant="standard" sx={{ m: 1, width: '100%'}}>
                <InputLabel id="demo-simple-select-standard-label">Beiratkozás napja</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="date-select"
                  value={day}
                  onChange={handleChange}
                  label="Age"
                >
                  <MenuItem value={4}>Május 4.</MenuItem>
                  <MenuItem value={5}>Május 5.</MenuItem>
                  <MenuItem value={6}>Május 6.</MenuItem>
                  <MenuItem value={7}>Május 7.</MenuItem>
                  <MenuItem value={8}>Május 8.</MenuItem>
                </Select>
              </FormControl>
              {day &&
                <div className='date-container'>
                  <Grid container spacing={2} justifyContent='center'>
                    {
                      dates.map(date =>(
                        <Grid item xs={4} key={date}>
                          {!takenDates.includes(day + "-" + date) ? <DateItemNeutral onClick={chosenDate} id={date}>{date}</DateItemNeutral> : <DateItemBad id={date}>{date}</DateItemBad>}
                        </Grid>
                      ))
                    }
                  </Grid>
                </div>
              }
              {errorInFill === true && 
              <>
                <h3 className="incorrect-fill">Az összes mező kitöltése és időpont választása kötelező</h3>
              </>
              }
              {!submitted ? 
                <div className='button'>
                    <Button variant="contained" type='submit'>Időpont foglalása</Button>
                </div>
                : null
              }
          </div>
        </form>
      </>
    );
  }
  else if (result === 'error') {
    return(
    <>

      <div className='error'>Hiba történt, kérlek próbáld újra</div>
      <div className='errorDesc'>Valószínűleg valaki egyidejűleg lefoglalta ugyanezt az időpontot és ő gyorsabb volt. Kérlek próbáld újra.<br/>
      Ha a hiba fennáll, akkor segítségért hívja: <br/>
      Bergman Ildikó óvodatitkár: +36 30 943 4046<br/></div>
    </>
    );
  }
  else if (result === 'thanks') {
    return(
    <>
      <div className='s'>Az időpontfoglalás sikeresen megtörtént!</div>
      <div className='email test'>Testvéreknek NEM kell kétszer foglalni!</div>
      <div className='email'>A visszaigazoló e-mailt elküldtünk.<br/>
      Ha a spam mappában sem találja, segítségért hívja: <br/>
      Bergman Ildikó óvodatitkár: +36 30 943 4046<br/>
      </div>
    </>
    );
  }
  else {
    console.log('error in result state');
    console.log(result);
  }
}

export default App;
